import React, { FC, useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import { useHideThemeElements } from "../../../app/common/_customHooks/useHideThemeElements";
import { createPortal } from "react-dom";

const animationStartClass = "dialog-shown";
const animationEndClass = "dialog-hidden";

type IProps = {
  isLoading: boolean;
  text: string;
  customClasses?: string[];
  hideUI?: boolean;
}

export const LoadingDialog:FC<IProps> = ({ isLoading, text, customClasses = [], hideUI = false }) => {
  useHideThemeElements(false, hideUI)

  const initCssClasses = [
    "dialog",
    "dialog-default",
    "dialog-loader",
    "dialog-top-center",
    ...customClasses,
  ];

  const [cssClasses, setCssClasses] = useState<string[]>(initCssClasses);

  useEffect(() => {
    // for animation start should toggle 'dialog-hidden' css class
    setCssClasses(initCssClasses);
      const cssClassForAdding = isLoading
        ? animationStartClass
        : animationEndClass;
      setCssClasses([...initCssClasses, cssClassForAdding]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const layoutPortal = document && document.getElementById("layout-portal")
  const contentPortal = document && document.getElementById("kt_content")

  return (
    <>
      {isLoading && (
        <>
          {layoutPortal &&
            createPortal(
              <div className={cssClasses.join(" ")}>{text}</div>,
              layoutPortal
            )
          }
          {contentPortal &&
            createPortal(
              <>
                <div className="fade content-backdrop show">
                </div>
                <span className="content-backdrop-loader">
                  <SVG
                    src={toAbsoluteUrl("/media/loading/loading.svg")}
                  />
                </span>
              </>,
              contentPortal
            )
          }
        </>
      )}
    </>
  );
}
